import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import type { ForensicsEnvironment } from '@/types/entities'

interface ForensicsDeleteDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    environment: ForensicsEnvironment | null
    onConfirm: () => void
    isLoading?: boolean
}

export function ForensicsDeleteDialog({
    open,
    onOpenChange,
    environment,
    onConfirm,
    isLoading = false,
}: ForensicsDeleteDialogProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Delete Forensics Environment</DialogTitle>
                    <DialogDescription>
                        Are you sure you want to delete &quot;{environment?.name}&quot;? This will stop all running
                        forensics instances and remove the environment. This action cannot be undone.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button variant="destructive" onClick={onConfirm} disabled={isLoading}>
                        {isLoading ? 'Deleting...' : 'Delete'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
